import { call, put, takeLeading } from 'redux-saga/effects';
import { authActions, LoginPayload } from '../reducers/auth-action';
import AuthService from '../api/authentication';
import * as uuid from 'uuid';

function* userLogin({ payload }: any): any {
  const res = yield call(AuthService.loginService, payload);
  if (res.status === 'success') {
    localStorage.setItem('iot_access_token', uuid.v4().toString());
    yield put(authActions.userLoginSuccess(res));
  } else {
    localStorage.removeItem('iot_access_token');
    yield put(authActions.userLoginFailed('ERROR'));
  }
}

function* userLogout({ payload }: any): any {
  try {
    localStorage.clear();
    // localStorage.removeItem('iot_access_token');
    yield put(authActions.userLogoutSuccess());
  } catch (error) {
    yield put(authActions.userLogoutFailed());
  }
}

function* checkUserLogin(): any {
  const res = yield call<any>(AuthService.checkAccessTokenService, 'HELLO');
  if (res.status === 'success') {
    yield put(authActions.checkUserLoginSuccess({ id: 1, username: 'John' }));
  } else {
    localStorage.removeItem('iot_access_token');
    yield put(authActions.checkUserLoginFailed());
  }
}

function* authSaga() {
  yield takeLeading('authentication/checkUserLogin', checkUserLogin);
  yield takeLeading('authentication/userLoginRequest', userLogin);
  yield takeLeading('authentication/userLogoutRequest', userLogout);
}

export default authSaga;
